// angular
//     .module("HeroPRO")
//     .directive("primaryInformation", PrimaryInformationDirective);


import _ from 'lodash';
import angular from 'angular';

/* @ngInject */
export default function PrimaryInformationDirective($window, $timeout, HPConfig) {
    function link(scope, element, attrs, ctrl) {
        const piParent = element.parent();
        const primaryInformation = piParent.children()[0];
        const appStepsDetail = piParent.children()[1];

        // Listen for window resize events and use a debounce function so that
        // setPrimaryInformationWidth is only called 200ms after the user has finished resizing.
        const debouncedCheckWindow = _.debounce(() => {
            setPrimaryInformationWidth(1);
            resetIsCollapsed(scope);
        }, 200);
        angular.element($window).bind('resize', debouncedCheckWindow);

        // To avoid an infinite loop, try to set the width for a maximum of 10 times
        setPrimaryInformationWidth(10);

        function setPrimaryInformationWidth(tries) {
            if (tries > 0) {
                if ($window.innerWidth >= HPConfig.screenSizes.screen_md) {
                    // Dynamically set the width of the primary-information element based on its parent
                    const elementWidth = element[0].parentNode.clientWidth;

                    // If the elementWidth is 0 the DOM has yet to be rendered. Recurse on this function if there are tries remaining.
                    if (elementWidth !== 0) {
                        element.css({ width: `${elementWidth}px` });
                    } else {
                        $timeout(() => {
                            setPrimaryInformationWidth(tries - 1);
                        }, 300);
                    }
                    appStepsDetail.style.marginTop = '25px';
                } else {
                    element.css({ width: 'auto' });
                    appStepsDetail.style.marginTop = '0';
                }
            }
        }

        function resetIsCollapsed(scope) {
            ctrl.isInfoCollapsed = $window.innerWidth < HPConfig.screenSizes.screen_md;
            ctrl.showCollapseIcon = $window.innerWidth < HPConfig.screenSizes.screen_md;
            scope.$apply();
        }

        // Observe piSetFixedHeight to determine whether the primary information header should have a fixed position
        attrs.$observe('piSetFixedHeight', setFixedHeaderStyles);

        function setFixedHeaderStyles(value) {
            const fixedHeight = scope.$eval(value);

            if ($window.innerWidth >= HPConfig.screenSizes.screen_md) {
                if (fixedHeight === true) {
                    primaryInformation.style.height = `${primaryInformation.clientHeight}px`;
                    appStepsDetail.style.marginTop = `${primaryInformation.clientHeight + 1 + 25}px`;
                    // margin-top = primary information height + 1px border + 25px default top margin of appStepsDetail
                } else {
                    primaryInformation.style.height = 'auto';
                    appStepsDetail.style.marginTop = '25px';
                }
            }
        }
    }


    return {
        restrict: 'E',
        controller: 'PrimaryInformationController',
        controllerAs: 'primaryInformation',
        bindToController: true,
        templateUrl: 'app/common/primaryInformation/primaryInformationTemplate.html',
        scope: {
            piInformationType: '@',
        },
        link,
    };
}



// WEBPACK FOOTER //
// ./src/app/common/primaryInformation/primaryInformationDirective.js